import React, { useEffect, useRef, useState } from 'react';
import { getBgColorByParty, getFontColorByParty, getStatusById } from './seatHelpers';
import CandidateIcons from './CandidateIcons';
import PartyArticlesPanel from './PartyArticlesPanel';
import { claimActive, releaseActive } from './activePartyPanel';

const CandidateBar = ({ candidate, totalVotes }) => {
  const total = parseInt(totalVotes) || 0;
  const votes = parseInt(candidate.votes) || 0;
  const votePercent = total > 0 ? ((votes / total) * 100).toFixed(2) : 0;
  const isWinner = candidate.status == 1;
  const [panelQuery, setPanelQuery] = useState(null);

  const closeFnRef = useRef(null);
  closeFnRef.current = () => setPanelQuery(null);

  useEffect(() => () => releaseActive(closeFnRef.current), []);

  const openPanel = () => {
    if (!candidate.party) return;
    claimActive(closeFnRef.current);
    setPanelQuery({ tag: candidate.party, fallbackTag: null });
  };

  // Clicking the candidate name searches that name first, falling back to the
  // party when the name has no related articles.
  const openNamePanel = () => {
    if (!candidate.candidate_name && !candidate.party) return;
    claimActive(closeFnRef.current);
    setPanelQuery({
      tag: candidate.candidate_name || candidate.party,
      fallbackTag: candidate.party,
    });
  };

  const handleClose = () => {
    releaseActive(closeFnRef.current);
    setPanelQuery(null);
  };

  return (
    <>
      <div className={`bar_chart_row ${isWinner ? 'winner' : ''}`}>
        {parseInt(candidate.status) > 0 && (
          <span className="winner_label">{getStatusById(candidate.status)}</span>
        )}
        <div
          className="bar_chart_label"
          role="button"
          tabIndex={0}
          onClick={openPanel}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              openPanel();
            }
          }}
        >
          <span className="bcl-icon">
            <CandidateIcons candidate={candidate} />
          </span>
          <span className="bcl-party">
            {candidate.party} {candidate.alliance && `(${candidate.alliance})`}
          </span>
          <span className="bcl-photo">
            {candidate.candidate_logo && (
              <img
                className="cand-photo"
                src={candidate.candidate_logo}
                alt=""
                onError={(e) => { e.target.style.display = 'none'; }}
              />
            )}
          </span>
          <span
            className="bcl-name"
            role="button"
            tabIndex={0}
            onClick={(e) => {
              e.stopPropagation();
              openNamePanel();
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                e.stopPropagation();
                openNamePanel();
              }
            }}
          >
            {candidate.candidate_name}
          </span>
        </div>
        <div className="bar_chart_bar_container">
          <div
            className="bar_chart_bar"
            style={{
              width: `${votePercent}%`,
              backgroundColor: getBgColorByParty(candidate.alliance_en),
            }}
          >
            <span
              className="bar_chart_votes"
              style={{ color: getFontColorByParty(candidate.alliance_en) }}
            >
              {votes.toLocaleString()}
            </span>
          </div>
        </div>
      </div>
      <PartyArticlesPanel
        tag={panelQuery?.tag}
        fallbackTag={panelQuery?.fallbackTag}
        onClose={handleClose}
      />
    </>
  );
};

export default CandidateBar;
